import CancelBox from "./CancelBox";
import SportsBox from "./SportsBox";
import LevelBox from "./LevelBox";
import TargetBox from "./TargetBox";
import AccommodationBox from "./AccommodationBox";
import EnvironmentBox from "./EnvironmentBox";
import { IoMapOutline } from "react-icons/io5";
import { motion } from "framer-motion";
import { Skeleton, Button, Empty } from "antd";
import { useTranslation } from "react-i18next";

// import DestinationsBox from "./DestinationsBox";
// import DateBox from "./DateBox";

const FilterBoxes = ({
  isFiltersLoading,
  filtersData,
  setFilters,
  filters,
  isFiltersLoadingInline,
  router,
  hasFilterReqFailed,
  getFiltersData,
  setOpenMap,
  openMap,
}) => {
  const { t } = useTranslation("common");

  const handleFilterSelection = (type, value, isChecked) => {
    setFilters((prevFilters) => {
      let updatedValue;

      if (type === "cancel") {
        updatedValue = isChecked ? 1 : [];
      } else {
        const currentValues = prevFilters[type];
        const currentArray = Array.isArray(currentValues)
          ? currentValues
          : currentValues
          ? [currentValues]
          : [];

        if (isChecked) {
          if (!currentArray.includes(value)) {
            updatedValue = [...currentArray, value];
          } else {
            updatedValue = currentArray;
          }
        } else {
          updatedValue = currentArray.filter((item) => item !== value);
        }

        if (updatedValue.length === 1) {
          updatedValue = updatedValue[0];
        } else if (updatedValue.length === 0) {
          updatedValue = [];
        }
      }

      const updatedFilters = {
        ...prevFilters,
        [type]: updatedValue,
      };

      const currentQuery = { ...router.query };
      delete currentQuery.slug;
      const newQuery = { ...currentQuery };
      newQuery.page = updatedFilters.page.toString();

      Object.entries(updatedFilters).forEach(([key, value]) => {
        if (key === "page") return;
        if (Array.isArray(value) && value.length > 0) {
          newQuery[key] = value;
        } else if (value === 1 || value === 0) {
          newQuery[key] = value.toString();
        } else if (value && typeof value === "string") {
          newQuery[key] = value;
        } else {
          delete newQuery[key];
        }
      });

      router.push(
        {
          pathname: router.pathname,
          query: {
            ...newQuery,
          },
        },
        undefined,
        { shallow: true }
      );

      return updatedFilters;
    });
  };

  return (
    <aside className="w-full">
      {!openMap && (
        <button
          className="w-full border border-green rounded-2xl bg-[#e3f9fc] p-3 hidden lg:flex items-center justify-center gap-3 cursor-pointer mb-4"
          onClick={() => setOpenMap(true)}
          aria-label={t("search.show_on_map")}
        >
          <IoMapOutline className="text-xl" />
          <p className="text-base font-medium text-black text-center">
            {t("search.show_on_map")}
          </p>
        </button>
      )}

      {!isFiltersLoading ? (
        <>
          {!hasFilterReqFailed ? (
            <div className="w-full flex flex-col gap-4">
              {/* {filtersData?.destinations?.continents?.length > 0 && (
                <DestinationsBox
                  data={filtersData?.destinations}
                  handleFilterSelection={handleFilterSelection}
                  isFiltersLoadingInline={isFiltersLoadingInline}
                  filters={filters}
                />
              )} */}
              {/* {filtersData?.months && (
                <DateBox
                  data={filtersData?.months}
                  handleFilterSelection={handleFilterSelection}
                  isFiltersLoadingInline={isFiltersLoadingInline}
                  setFilters={setFilters}
                  selectedFilters={filters.month}
                />
              )} */}
              {/* {filtersData?.sports?.categories?.length > 0 && ( */}
              {filtersData?.sports?.categories?.[0]?.sub_categories?.length >
                0 && (
                <SportsBox
                  data={filtersData?.sports?.categories}
                  handleFilterSelection={handleFilterSelection}
                  isFiltersLoadingInline={isFiltersLoadingInline}
                  filters={filters}
                />
              )}

              {filtersData?.levels?.length > 0 && (
                <LevelBox
                  data={filtersData?.levels}
                  handleFilterSelection={handleFilterSelection}
                  isFiltersLoadingInline={isFiltersLoadingInline}
                  selectedFilters={filters.levels}
                />
              )}

              {filtersData?.targets?.length > 0 && (
                <TargetBox
                  data={filtersData?.targets}
                  handleFilterSelection={handleFilterSelection}
                  isFiltersLoadingInline={isFiltersLoadingInline}
                  selectedFilters={filters.group}
                />
              )}

              {filtersData?.room_types?.length > 0 && (
                <AccommodationBox
                  data={filtersData?.room_types}
                  handleFilterSelection={handleFilterSelection}
                  isFiltersLoadingInline={isFiltersLoadingInline}
                  selectedFilters={filters.roomType}
                />
              )}

              {filtersData?.environments?.length > 0 && (
                <EnvironmentBox
                  data={filtersData?.environments}
                  handleFilterSelection={handleFilterSelection}
                  isFiltersLoadingInline={isFiltersLoadingInline}
                  selectedFilters={filters.environments}
                />
              )}

              {filtersData?.cancel_policies?.title_en && (
                <CancelBox
                  data={filtersData?.cancel_policies}
                  handleFilterSelection={handleFilterSelection}
                  isFiltersLoadingInline={isFiltersLoadingInline}
                  selectedFilters={filters.cancel}
                />
              )}
            </div>
          ) : (
            <motion.div
              className="w-full flex flex-col gap-4"
              initial={{ opacity: 0.9, y: 15 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{
                duration: 0.1,
                type: "spring",
                stiffness: 300,
                damping: 50,
              }}
            >
              <div className="w-full border-t-green border-t-4 py-3 lg:px-5 px-4 border rounded-2xl h-[260px] flex flex-col items-center justify-center gap-3">
                <Empty
                  description="Failed to load filter data!"
                  className="[&_.ant-empty-description]:text-base [&_.ant-empty-description]:font-medium [&_.ant-empty-description]:text-center"
                />
                <Button
                  className="btn-orange px-12 text-base font-medium !bg-orange !text-white"
                  onClick={getFiltersData}
                >
                  Try again
                </Button>
              </div>
            </motion.div>
          )}
        </>
      ) : (
        <div className={`w-full flex flex-col gap-4`}>
          {Array.from({ length: 9 }, (_, i) => (
            <Skeleton.Button
              active
              key={"filter-box-placeholder-" + i}
              className={`!h-[260px] !w-full pb-4 ${i == 2 && "!h-[150px]"} ${
                i === 3 && "!h-[280px]"
              } ${
                i === 4 && "!h-[200px]"
              } border-t-green border-t-2 !rounded-2xl overflow-hidden`}
            />
          ))}
        </div>
      )}
    </aside>
  );
};

export default FilterBoxes;
